import React from "react";
import DownloadButton from "./DownloadButton";
import GooglePlayButton from "./GooglePlayButton";

type DownloadButtonsGroupProps = {
  className?: string;
  variant?: 'black' | 'white';
};

const DownloadButtonsGroup: React.FC<DownloadButtonsGroupProps> = ({ className = "", variant = 'black' }) => (
  <div className={`flex flex-wrap items-center gap-3 ${className}`}>
    <DownloadButton variant={variant} />
    <GooglePlayButton />
  </div>
);

export default DownloadButtonsGroup;

